export default function IconConfirmPork() {
  return (
    <svg viewBox="0 0 112 135" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M103.3 95.2C103.3 94.4 103.4 93.5 103.4 92.6C103.8 92.6 104.1 92.5 104.6 92.5C104.6 93.3 104.7 94.1 104.5 94.8C104.5 95 103.7 95 103.3 95.2C103.2 95.1 103.3 95.2 103.3 95.2Z"
          fill="#00FF00"
        />
        <path
          d="M57.2 78.4C56.5 78.4 55.8 78.2 55.7 79.4C55.7 79.6 55 79.7 54.5 79.9C54.5 77.8 54.5 76.1 54.5 74.3C54 74.2 53.6 74.1 53.1 74C53.1 73.1 53 72.3 53 71.4C52.5 71.3 52.2 71.3 51.8 71.2C51.7 70.8 51.7 70.4 51.6 70C51.2 69.9 50.8 69.9 50.4 69.8C50.3 69.4 50.2 69.1 50.1 68.6C49.3 68.5 48.5 68.5 47.6 68.4C47.5 68 47.5 67.6 47.4 67.2C47 67.1 46.7 67.1 46.2 67C46.1 66.6 46 66.2 45.9 65.8C45.2 65.7 44.4 65.8 44.4 64.8C44.4 64.7 43.9 64.5 43.6 64.5C42.6 64.4 41.6 64.4 40.5 64.3C40.4 63.9 40.3 63.5 40.2 63C38.9 63 37.7 63 36.3 63C36.2 62.5 36.1 62.1 35.9 61.6C34.6 61.6 33.4 61.6 32.1 61.6C31.5 60.2 31 59.9 29.6 60.3C29.4 60.4 29.1 60.5 29.1 60.7C29 61.7 28.3 61.6 27.7 61.6C25.7 61.6 23.7 61.7 21.6 61.7C21.1 61.7 20.7 61.8 20.5 62.5C20.4 62.8 19.9 63 19.4 63.3C19.3 62.6 19.2 62.2 19.2 61.8C18.8 61.7 18.5 61.7 18 61.6C18 60.5 17.9 59.5 17.8 58.4C17.8 58.1 17.5 57.6 17.2 57.6C16.4 57.5 16.4 57 16.6 56.4C17 56.3 17.4 56.2 17.8 56.2C17.8 55.8 17.9 55.4 17.9 55C19.9 54.9 18.9 53.2 19.4 52.2C19.7 52.2 20.1 52.1 20.5 52C20.6 51.6 20.6 51.3 20.7 50.8C22.8 50.8 21.7 49 22.2 48C22.5 47.9 22.9 47.9 23.4 47.8C23.5 47.4 23.5 47.1 23.6 46.6C23.9 46.5 24.3 46.5 24.8 46.4C24.9 46.1 24.9 45.7 25 45.2C25.4 45.1 25.8 45 26.2 44.9C26.3 44.5 26.3 44.2 26.4 43.7C26.8 43.6 27.2 43.6 27.6 43.5C27.7 43.1 27.7 42.8 27.8 42.3C28.2 42.2 28.6 42.2 29 42.1C29 41.7 29.1 41.3 29.2 40.9C29.6 40.8 30 40.8 30.4 40.7C30.5 40.3 30.5 40 30.6 39.5C31 39.4 31.4 39.4 31.8 39.3C31.8 38.9 31.9 38.6 31.9 38.1C32.3 38 32.7 38 33.1 37.9C33.2 37.5 33.2 37.1 33.3 36.7C33.7 36.6 34.1 36.6 34.5 36.5C34.6 36.1 34.6 35.7 34.7 35.3C35.1 35.2 35.4 35.1 35.9 35.1C36.2 34.2 36.1 33.6 34.9 33.7C34.4 33.7 33.8 33.7 33.2 33.7C33.1 34.2 33.1 34.5 33 35C32.2 35.1 31.3 35.1 30.4 35.2C30.3 35.6 30.3 36 30.2 36.4C29.8 36.5 29.4 36.5 29 36.6C28.9 37 28.8 37.4 28.8 37.9C28 37.9 27.2 38 26.3 38C26.2 38.4 26.1 38.8 26 39.3C25.6 39.3 25.2 39.4 24.8 39.5C24.8 39.9 24.7 40.3 24.6 40.7C24.3 40.7 23.9 40.7 23.5 40.8C23.4 40.2 23.4 39.7 23.3 39.1C23.2 38.8 23.1 38.2 22.9 38.2C22 38.1 21.9 37.5 22 36.7C21.6 36.6 21.2 36.5 20.5 36.4C20.5 35 20.5 33.5 20.5 32C20.5 31.7 20.3 31.1 20.1 31.1C18.9 31 19.2 30.2 19.2 29.5C19.2 28.2 19.2 26.9 19.2 25.5C18.7 25.4 18.3 25.3 17.8 25.2C17.8 23.5 17.8 21.7 17.8 19.9C17.3 19.8 16.9 19.7 16.4 19.6C16.4 18.7 16.4 17.7 16.4 16.7C16.4 15.9 16.4 15.1 16.4 14.4C16.4 13.6 16.6 12.5 15 12.8C15 11.3 15 10 15 8.7C14.5 8.6 14.1 8.6 13.7 8.5C13.7 7.6 13.6 6.8 13.6 5.9C13.2 5.8 12.8 5.8 12.4 5.7C12.3 5.4 12.4 5.1 12.2 5C11.9 4.8 11.4 4.7 11 4.6C11.2 5 11 5.6 11 6.2C11 6.5 11.3 7 11.6 7C12.3 7.1 12.3 7.5 12.3 8.1C12.3 8.7 12.3 9.3 12.3 9.8C12.3 10.7 12.3 11.5 13.7 11.3C13.7 13.4 13.7 15.4 13.7 17.4C13.7 18.2 13.8 19 13.7 19.7C13.6 20.6 14 21.1 15 21.1C15 24.3 15 27.5 15 30.7C16.4 30.7 16.4 31.4 16.4 32.4C16.4 34.3 16.4 36.2 16.5 38.1C16.5 38.4 17 38.7 17.2 39.1C17.4 39.6 17.7 40.1 17.7 40.5C17.8 41.4 17.8 42.1 19 42C19 43.3 19 44.6 19 45.9C17 46 18 47.6 17.6 48.7C17.3 48.8 16.9 48.9 16.4 48.9C16.4 49.3 16.3 49.6 16.3 50.1C15.9 50.2 15.5 50.3 15.1 50.4C15 51.2 15 52.1 14.9 53C14.1 53 13.3 53 12.4 53C12.3 50.9 10.6 52 9.6 51.5C9.5 51.2 9.5 50.8 9.4 50.3C8.6 50.3 7.8 50.2 6.8 50.2C6.7 49.8 6.7 49.4 6.6 49C6.4 49 6 48.9 5.6 48.8C5.5 48.4 5.5 48.1 5.4 47.6C5 47.5 4.6 47.5 4.1 47.4C4.1 45.6 4.1 43.9 4.1 42.1C3.6 42 3.2 42 2.7 41.9C2.7 40.6 2.7 39.3 2.7 38C2.7 36.7 2.6 36.7 1.3 36.3C1.3 35 1.3 33.7 1.3 32.4C0.8 32.3 0.4 32.3 0 32.2C0 31.4 0 30.6 0 29.7C0.4 29.6 0.7 29.5 1.3 29.4C1.3 27.5 1.3 25.6 1.3 23.8C1.3 23.2 1.2 22.5 2.1 22.5C2.3 22.5 2.5 21.9 2.6 21.6C2.7 19.6 2.7 17.6 2.7 15.7C2.7 14.5 2.7 14.5 4 14.2C4 12 4 9.8 4 7.5C4.5 7.4 4.9 7.4 5.3 7.3C5.4 6.9 5.4 6.5 5.5 6.1C6 5.8 6.3 5.7 6.8 5.6C6.8 4.8 6.9 4 7 3.1C7.4 3 7.8 2.9 8.2 2.8C8.2 2.4 8.3 2 8.3 1.7C8.4 1.8 8.5 1.8 8.6 1.9C9 1.4 9.3 1 9.7 0.6C10 0.4 10.3 0.3 10.8 0C10.9 0.6 11 1 11 1.5C11.4 1.5 11.8 1.6 12.2 1.6C12.3 2 12.3 2.4 12.4 2.8C12.8 2.9 13.2 3 13.6 3C13.6 5.1 15.4 4 16.4 4.5C16.5 4.8 16.5 5.2 16.6 5.6C17 5.7 17.3 5.7 17.8 5.8C17.9 6.2 18 6.6 18 7.1C18.4 7.1 18.7 7.2 19.2 7.3C19.3 7.7 19.3 8.1 19.4 8.5C19.8 8.6 20.1 8.6 20.6 8.7C20.7 9.4 20.8 10.2 21.8 10C21.9 10 22 10.1 22 10.1C22.3 11.8 23.7 11.2 24.7 11.5C24.8 11.9 24.8 12.3 24.9 12.7C25.3 12.7 25.7 12.8 26.1 12.8C26.2 13.2 26.2 13.6 26.3 14C26.7 14.1 27 14.1 27.5 14.2C27.6 14.6 27.7 15 27.7 15.4C28.1 15.5 28.5 15.5 28.9 15.6C29 16 29 16.4 29.1 16.8C29.8 16.9 30.6 16.9 30.6 17.9C30.6 18 31.1 18.2 31.4 18.2C33.3 18.3 35.3 18.3 37.2 18.3C37.7 18.3 38.1 18.3 38.7 18.3C38.7 18.8 38.7 19.2 38.7 19.7C38.7 25.4 38.7 31.1 38.7 36.8C38.7 39.3 38.7 39.3 41.2 39.3C42.2 39.3 43.1 39.3 44.1 39.3C44.2 39.8 44.3 40.1 44.4 40.7C45 40.7 45.6 40.7 46.3 40.7C47 40.7 47.6 40.7 48.3 40.7C48.4 41.1 48.5 41.5 48.6 42.1C49.6 42.1 50.7 42.1 51.7 42.1C52 42.1 52.6 42.3 52.6 42.5C52.7 43.3 53.2 43.4 53.8 43.4C55.2 43.4 56.7 43.4 58.2 43.4C58.3 43 58.3 42.6 58.4 42C59.8 42 61.1 42 62.5 42C63.1 42 63.8 42 63.8 41.1C63.8 40.9 64.3 40.7 64.6 40.7C65.7 40.7 66.8 40.7 67.9 40.7C68 40.2 68.1 39.8 68.2 39.3C69.5 39.3 70.8 39.3 72.2 39.3C72.3 38.8 72.3 38.4 72.4 38C72.8 37.9 73.2 37.9 73.7 37.8C73.7 31.4 73.7 25 73.7 18.4C76.1 18.4 78.3 18.4 80.6 18.4C80.7 17.9 80.8 17.5 80.9 17.2C81.7 16.5 83.6 17.8 83.6 15.7C84 15.6 84.4 15.6 84.8 15.5C84.9 15.1 85 14.7 85.1 14.3C85.5 14.2 85.9 14.2 86.3 14.1C86.4 13.7 86.4 13.3 86.5 12.9C86.9 12.8 87.3 12.8 87.7 12.7C87.8 12.3 87.8 12 87.9 11.5C88.3 11.4 88.7 11.3 89.1 11.3C89.2 10.9 89.2 10.5 89.3 10.1C89.7 10 90.1 10 90.5 9.9C90.6 9.5 90.6 9.2 90.7 8.7C91.2 8.6 91.8 8.6 92.3 8.5C92.7 8.4 92.9 8 93.3 7.8C93.7 7.5 94.1 7.2 94.7 6.8C94.7 6.8 94.8 6.4 94.9 5.9C95.3 5.8 95.6 5.8 96.1 5.7C96.2 5.3 96.3 4.9 96.4 4.5C96.8 4.5 97.2 4.4 97.6 4.3C97.7 3.9 97.7 3.5 97.8 3.2C98.6 2.5 100.5 3.9 100.6 1.7C101 1.6 101.4 1.5 101.9 1.4C102 1 102 0.7 102.1 0.2C102.5 0.2 102.8 0.2 103.2 0.1C103.3 0.6 103.3 0.9 103.4 1.4C103.8 1.5 104.1 1.5 104.5 1.6C105.2 2.4 103.8 4.4 106 4.4C106.1 4.8 106.1 5.2 106.2 5.6C106.6 5.7 106.9 5.7 107.5 5.8C107.5 6.6 107.5 7.5 107.5 8.4C107.5 9.3 107.6 10.1 108.9 9.9C108.9 12.2 108.9 14.4 108.9 16.7C109.4 16.8 109.8 16.9 110.3 16.9C110.3 19.1 110.3 21.4 110.3 23.7C111.6 23.6 111.7 24.3 111.7 25.3C111.7 28.4 111.7 31.5 111.7 34.7C110.3 34.6 110.3 35.6 110.3 36.5C110.3 37.7 110.3 39 110.3 40.3C109.8 40.4 109.4 40.4 108.9 40.5C108.9 41.6 109 42.6 108.9 43.7C108.9 44 108.5 44.3 108.2 44.7C108 45 107.7 45.2 107.6 45.5C107.5 46.5 107.5 47.6 107.4 48.7C106.5 48.8 105.7 48.8 104.9 48.9C104.8 49.3 104.7 49.7 104.6 50.1C104.3 50.2 103.9 50.2 103.4 50.3C103.3 50.7 103.2 51.1 103.1 51.6C102.3 51.6 101.4 51.7 100.5 51.7C100.4 52.1 100.4 52.5 100.3 53C99.5 53 98.7 53 97.8 53C97.7 52.6 97.7 52.2 97.6 51.8C97.2 51.7 96.9 51.7 96.4 51.6C96.3 50.8 96.3 50 96.2 49.1C95.8 49 95.4 48.9 95 48.9C94.9 48.5 94.9 48.1 94.8 47.7C94.4 47.6 94 47.5 93.6 47.5C93.6 47 93.5 46.6 93.5 46.1C93.5 45.4 93.5 44.9 92.6 44.8C92.4 44.8 92.3 44.1 92.1 43.7C92.7 43.6 93.1 43.5 93.6 43.5C93.6 42.6 93.7 41.8 93.7 40.9C94.1 40.8 94.5 40.8 95 40.7C95 39.9 95.1 39 95.1 38.1C95.5 38 95.9 37.9 96.4 37.8C96.4 34.7 96.4 31.5 96.4 28.3C98 28.4 97.9 27.3 97.9 26.4C97.9 23.7 97.9 21 97.9 18.4C97.9 17.5 98.1 17 99.2 17.1C99.2 14.8 99.2 12.6 99.2 10.2C100.7 10.3 100.7 9.3 100.7 8.3C100.7 7.3 100.7 6.2 100.6 5.2C100.6 4.9 100.1 4.7 99.9 4.4C99.7 4.7 99.3 4.9 99.2 5.2C99.1 5.8 99.2 6.4 99.2 7C98.7 7.1 98.3 7.2 97.8 7.4C97.8 8.7 97.8 9.9 97.8 11.2C97.3 11.3 96.9 11.4 96.4 11.5C96.4 13.2 96.4 15 96.4 16.8C94.8 16.7 95 17.8 95 18.7C95 20 95 21.3 95 22.5C95 23.7 95 23.7 93.7 23.9C93.7 25.6 93.7 27.4 93.7 29.2C93.2 29.3 92.8 29.4 92.3 29.6C92.3 31.3 92.3 33.1 92.3 34.8C91.8 34.9 91.4 35 90.9 35.2C90.9 36 90.8 36.8 90.7 37.7C90.3 37.8 89.9 37.8 89.4 37.9C89.4 38.7 89.4 39.5 89.4 40.5C88.9 40.5 88.6 40.5 88.2 40.6C88.1 40.1 88.1 39.7 88 39.3C87.3 39.2 86.5 39.2 86.5 38.2C86.5 38.1 85.9 37.9 85.5 37.8C85 37.7 84.6 37.7 84.1 37.6C84 37.2 84 36.9 83.9 36.5C83.1 35.7 81.1 37.3 81.1 35C80.7 34.9 80.3 34.9 79.9 34.8C79.8 34.4 79.7 34 79.6 33.6C78.7 33.6 77.8 33.6 76.9 33.6C76.9 34.1 76.9 34.5 76.9 35C77.3 35.1 77.7 35.1 78.1 35.2C78.2 35.7 78.2 36.3 78.3 36.8C78.4 37.2 78.8 37.5 79.1 37.8C79.3 38 79.6 38.1 79.6 38.3C79.7 38.9 79.9 39.2 80.5 39.2H80.6C81.2 39.9 81.8 40.7 82.4 41.4C82.5 41.5 82.5 41.7 82.5 41.7C83.4 41.8 83.8 42.5 84.3 43.2C84.5 43.4 85.1 43.4 85.5 43.4C85.8 43.4 86 43.4 86.4 43.5C86.5 43.9 86.6 44.3 86.7 44.8C87.1 44.8 87.5 44.9 87.9 45C88 45.4 88 45.8 88.1 46.2C88.5 46.3 88.8 46.3 89.3 46.4C89.4 47.2 89.4 48 89.5 48.9C89.9 49 90.3 49.1 90.7 49.2C90.8 49.6 90.8 49.9 90.9 50.4C91.3 50.5 91.7 50.6 92.1 50.7C92.1 51.3 92.1 52 92.3 52.5C92.5 52.9 93 53.2 93.5 53.4C93.5 53.8 93.6 54.1 93.6 54.6C94 54.7 94.4 54.7 94.9 54.8C94.9 56.5 94.9 58.2 94.9 60C94.5 60.1 94.1 60.2 93.6 60.3C93.6 61.1 93.5 61.9 93.5 62.8C91.7 63.3 91.1 63.1 90.7 61.6C88 61.6 85.3 61.6 82.6 61.6C82.6 61.5 82.7 61.4 82.7 61.3C82.4 60.9 82 60.6 81.7 60.2C81.3 60.5 81 60.9 80.6 61.2C80.7 61.3 80.7 61.4 80.8 61.5C79.5 61.5 78.2 61.5 76.8 61.5C76.7 62 76.7 62.4 76.6 62.9C75.3 62.9 74 62.9 72.6 62.9C72.5 63.4 72.4 63.8 72.3 64.3C71 64.3 69.7 64.3 68.4 64.3C68.3 64.8 68.2 65.2 68.1 65.6C67.7 65.7 67.3 65.7 66.9 65.8C66.8 66.2 66.8 66.6 66.7 67C65.9 67.1 65.1 67.1 64.2 67.2C64.1 67.6 64 67.9 63.9 68.4C63.5 68.5 63.1 68.5 62.7 68.6C62.6 69 62.6 69.4 62.5 69.8C62.1 69.9 61.7 69.9 61.3 70C61.2 70.4 61.2 70.7 61.1 71.2C60.7 71.3 60.3 71.4 59.9 71.5C59.8 71.9 59.8 72.3 59.7 72.7C59.3 72.8 58.9 72.8 58.4 72.9C58.4 74 58.4 75 58.4 76.1C58.4 76.4 58.2 76.9 58 76.9C57 76.9 57.2 77.7 57.2 78.4Z"
          fill="#00FF00"
        />
        <path
          d="M46 18.3001C46 17.9001 46.1 17.5001 46.2 17.0001C48 17.0001 49.8 17.0001 51.7 17.0001C51.5 15.7001 52.3 15.6001 53.2 15.6001C55.4 15.6001 57.6 15.6001 59.9 15.6001C59.9 16.8001 60.6 17.0001 61.5 17.0001C62.4 17.0001 63.4 17.0001 64.3 17.0001C64.8 17.0001 65.6 16.6001 65.6 17.6001C65.6 18.5001 64.8 18.1001 64.4 18.2001C63.9 18.3001 63.4 18.2001 62.9 18.2001C62.9 19.7001 62.9 21.0001 62.9 22.5001C64.3 22.5001 65.7 22.5001 67.2 22.5001C67.2 21.4001 67.2 20.4001 67.2 19.3001C67.2 18.6001 67.4 18.3001 68.1 18.3001C69.1 18.3001 70.1 18.3001 71.2 18.3001C71.2 23.9001 71.2 29.3001 71.2 34.8001C70.8 34.9001 70.4 35.0001 70 35.1001C69.9 35.5001 69.9 35.8001 69.8 36.3001C68.5 36.3001 67.2 36.3001 65.9 36.3001C65.8 36.8001 65.7 37.2001 65.6 37.7001C64.3 37.7001 63 37.7001 61.6 37.7001C61.7 39.1001 61 39.1001 60 39.1001C57.4 39.1001 54.7 39.1001 52 39.1001C51.9 38.7001 51.8 38.3001 51.7 37.8001C50.4 37.8001 49.1 37.8001 47.7 37.8001C47.8 36.3001 46.8 36.3001 45.9 36.3001C44.9 36.3001 43.9 36.3001 42.9 36.2001C42.6 36.2001 42.1 35.8001 42.1 35.5001C42.1 29.8001 42.1 24.1001 42.1 18.1001C43.3 18.3001 44.6 18.3001 46 18.3001C46 19.7001 46 21.0001 46 22.5001C47.4 22.5001 48.8 22.5001 50.1 22.5001C50.1 21.0001 50.1 19.7001 50.1 18.3001C48.7 18.3001 47.3 18.3001 46 18.3001ZM45.9 25.2001C45.9 26.5001 45.9 27.6001 45.9 28.8001C45.9 29.0001 46.3 29.4001 46.5 29.4001C47.7 29.5001 48.9 29.4001 50.1 29.4001C50.1 27.9001 50.1 26.5001 50.1 25.1001C48.7 25.2001 47.4 25.2001 45.9 25.2001ZM58.6 22.5001C58.6 21.2001 58.6 20.0001 58.6 18.8001C58.6 18.6001 58.3 18.2001 58.1 18.2001C56.9 18.1001 55.7 18.2001 54.4 18.2001C54.4 19.7001 54.4 21.1001 54.4 22.5001C55.8 22.5001 57.1 22.5001 58.6 22.5001ZM62.7 35.0001C67 35.4001 67.3 35.1001 67 31.6001C67 31.5001 67 31.3001 67 31.3001C66.9 31.1001 66.7 30.9001 66.6 30.9001C65.3 30.9001 64.1 30.9001 62.8 30.9001C62.7 32.3001 62.7 33.6001 62.7 35.0001ZM58.6 35.1001C58.6 33.8001 58.6 32.6001 58.6 31.4001C58.6 31.2001 58.3 30.9001 58.1 30.9001C56.9 30.8001 55.7 30.9001 54.4 30.9001C54.4 32.4001 54.4 33.8001 54.4 35.2001C55.8 35.1001 57.1 35.1001 58.6 35.1001ZM50.2 35.1001C50.2 33.6001 50.2 32.3001 50.2 30.9001C48.7 30.9001 47.4 30.9001 46 30.9001C46 32.4001 46 33.7001 46 35.1001C47.4 35.1001 48.7 35.1001 50.2 35.1001ZM62.7 29.5001C64 29.5001 65.1 29.5001 66.2 29.5001C66.5 29.5001 66.9 29.2001 66.9 29.0001C67 27.8001 66.9 26.6001 66.9 25.3001C65.4 25.3001 64.1 25.3001 62.7 25.3001C62.7 26.7001 62.7 28.0001 62.7 29.5001ZM54.3 29.5001C55.6 29.5001 56.8 29.5001 58 29.5001C58.2 29.5001 58.5 29.2001 58.5 29.0001C58.6 27.8001 58.5 26.6001 58.5 25.4001C57 25.4001 55.6 25.4001 54.2 25.4001C54.3 26.7001 54.3 28.0001 54.3 29.5001Z"
          fill="#00FF00"
        />
        <path
          d="M40.6 116.3C41 116.2 41.4 116.2 41.8 116.2C41.9 115.8 41.9 115.4 42 115C42.4 114.9 42.7 114.9 43.2 114.8C43.3 114.4 43.3 114 43.4 113.6C43.8 113.5 44.2 113.4 44.6 113.4C44.7 113 44.7 112.6 44.8 112.2C45.2 112.1 45.6 112.1 46 112C46.1 111.6 46.1 111.2 46.2 110.7C47.5 110.7 48.8 110.7 50.1 110.7C50.2 110.2 50.3 109.8 50.4 109.3C51.7 109.3 53 109.3 54.3 109.3C54.4 108.8 54.5 108.4 54.6 107.9C55.7 107.9 56.9 107.8 58 108C58.3 108 58.5 108.7 58.9 109.3C59.5 109.3 60.3 109.3 61.1 109.3C62 109.3 62.9 109.2 62.6 110.7C63.7 110.7 64.6 110.7 65.5 110.7C66.4 110.6 66.9 110.9 66.8 112C67.2 112.1 67.6 112.2 68.1 112.2C68.2 112.8 68.2 113.4 68.3 113.9C68.3 114.1 68.5 114.5 68.5 114.5C69.8 114.3 69.3 116.5 70.6 116.2C70.7 116.2 70.7 116.3 70.9 116.3C71 116.6 71 117 71.1 117.4C71.5 117.5 71.9 117.5 72.3 117.6C72.3 120.3 72.3 122.9 72.3 125.6C71.9 125.7 71.5 125.7 71.1 125.8C71 126.2 71 126.6 70.9 127C70.5 127.1 70.2 127.1 69.7 127.2C69.6 127.6 69.5 128 69.4 128.5C68.6 128.5 67.7 128.5 66.9 128.5C66.8 129 66.8 129.4 66.7 129.8C65.8 129.8 65 129.9 64.1 129.9C64 130.3 64 130.7 63.9 131.1C58.9 131.1 53.9 131.1 48.9 131.1C48.8 130.7 48.8 130.4 48.7 129.9C47.9 129.9 47 129.8 46.1 129.8C46 129.4 45.9 129 45.8 128.5C45 128.5 44.2 128.4 43.3 128.4C43.1 127.8 43.2 126.9 42.1 127C42 127 41.8 126.8 41.7 126.6C41.4 126.2 41 125.7 40.7 125.3C40.6 125.4 40.5 125.4 40.4 125.5C40.3 125.1 40.3 124.8 40.2 124.3C39.8 124.2 39.4 124.2 38.9 124.1C38.9 122.5 38.9 120.9 38.9 119.3C38.9 119.2 38.9 118.9 39 118.9C40.9 118.8 40.3 117.4 40.6 116.3ZM58.6 128.8C58.6 122.8 58.6 117.1 58.6 111.3C58.6 111 58.2 110.6 58 110.6C56.8 110.5 55.6 110.6 54.3 110.6C54.4 111.6 53.9 112.1 52.9 112C52.9 117.5 52.9 122.8 52.9 128.2C52.9 128.4 53.3 128.8 53.5 128.8C55.2 128.8 56.8 128.8 58.6 128.8ZM61.3 113.3C61.3 113.9 61.3 114.3 61.3 114.7C61.3 118.6 61.3 122.5 61.3 126.5C61.3 128.9 61.4 129 63.9 128.8C64 128.8 64 128.7 64.1 128.7C64.2 128.3 64.3 127.9 64.4 127.5C65.3 127.5 66.1 127.4 67 127.4C67 122.9 67 118.5 67 114.1C67 113.8 66.5 113.4 66.3 113.4C64.6 113.3 63.1 113.3 61.3 113.3ZM50.2 128.7C50.2 123.5 50.2 118.4 50.2 113.3C48.8 113.3 47.4 113.3 46 113.3C45.9 113.8 45.9 114.1 45.8 114.5C45.4 114.6 45 114.6 44.5 114.7C44.5 115.2 44.5 115.6 44.5 116C44.5 118.9 44.4 121.7 44.5 124.6C44.6 127.5 44.3 127.2 47.1 127.3C48 127.3 48.8 127.4 48.7 128.6C49.2 128.7 49.7 128.7 50.2 128.7Z"
          fill="#00FF00"
        />
        <path
          d="M45.8 95C42.1 95 38.6 95 34.9 95C34.9 94.6 34.9 94.3 34.8 93.9C35.3 93.8 35.6 93.8 36.1 93.7C36.2 93.3 36.2 93 36.3 92.5C36.7 92.4 37.1 92.3 37.5 92.2C37.5 91.8 37.6 91.5 37.7 91C38.1 90.9 38.5 90.9 38.9 90.8C39 90.1 39 89.3 40 89.3C40.1 89.3 40.3 88.6 40.3 88.3C40.4 87.9 40.4 87.4 40.5 86.8C42.3 86.8 44 86.8 45.8 86.8C45.9 86.3 46 85.9 46.2 85.4C47.5 85.4 48.8 85.4 50.1 85.4C50.2 84.9 50.2 84.5 50.3 84C52 84 53.8 84 55.5 84C55.9 83.3 55.6 82.1999 56.9 82.6999C57 82.9999 57 83.4 57.1 83.9C58.4 83.9 59.7 83.9 61.1 83.9C61 85.5 62.1 85.4 63 85.4C64.2 85.4 65.4 85.4 66.6 85.4C66.7 85.9 66.7 86.3 66.8 86.8C68.1 86.8 69.4 86.8 70.8 86.8C70.9 87.3 71 87.7 71.1 88.1C71.5 88.2 71.8 88.2 72.3 88.3C72.4 88.7 72.4 89.1 72.5 89.5C72.9 89.6 73.2 89.5999 73.7 89.6999C73.8 90.0999 73.9 90.5 73.9 90.9C74.3 91 74.7 91 75.1 91.1C75.2 91.5 75.2 91.9 75.3 92.2C76.7 92.5999 76.9 93 76.5 94.9C72.9 94.9 69.3 94.9 65.7 94.9C65.6 94.5 65.6 94.0999 65.5 93.7C65.1 93.5999 64.7 93.6 64.3 93.5C64.2 93.1 64.2 92.8 64.1 92.3C63.7 92.2 63.3 92.1 62.9 92.1C62.8 91.7 62.8 91.4 62.7 90.9C58.5 90.9 54.4 90.9 50.2 90.9C50.1 91.3 50.1 91.6 50 92.1C49.6 92.2 49.2 92.2 48.8 92.3C48.8 92.7 48.7 93.1 48.7 93.4C47.7 94.1 45.9 92.9 45.8 95Z"
          fill="#00FF00"
        />
        <path
          d="M39.1 76.7999C39.1 76.3999 39 75.9999 39 75.5999C38.6 75.4999 38.2 75.4999 37.8 75.3999C37.7 74.9999 37.7 74.5999 37.6 74.1999C37.2 74.0999 36.9 74.0999 36.4 73.9999C36.3 73.5999 36.2 73.1999 36.1 72.7999C35.7 72.6999 35.3 72.6999 34.9 72.5999C34.8 72.1999 34.8 71.7999 34.7 71.3999C32.4 71.3999 30.1 71.3999 27.8 71.3999C27.7 71.7999 27.6 72.1999 27.6 72.5999C24.4 72.5999 21.3 72.5999 18.2 72.5999C18.1 72.1999 18.1 71.7999 18 71.3999C16.6 70.9999 16.7 70.9999 16.7 68.3999C16.7 66.0999 18.6 67.6999 19.4 66.8999C19.4 66.6999 19.5 66.2999 19.6 65.7999C21.5 65.7999 23.4 65.7999 25.3 65.7999C26.3 65.7999 27.3 65.6999 28.3 65.6999C28.5 65.6999 29 65.4999 29 65.3999C29.2 64.0999 30.2 64.4999 31 64.3999C31.3 64.3999 31.5 64.3999 31.8 64.4999C31.9 64.8999 31.9 65.2999 32 65.7999C33.3 65.7999 34.6 65.7999 35.9 65.7999C36 66.2999 36.1 66.6999 36.2 67.1999C37.5 67.1999 38.8 67.1999 40.1 67.1999C40.2 67.6999 40.3 68.0999 40.4 68.5999C41.2 68.5999 42 68.6999 42.9 68.6999C43 69.0999 43.1 69.4999 43.2 69.9999C43.7 69.9999 44.1 70.0999 44.6 70.0999C45.2 70.0999 46 69.9999 46 70.9999C46 71.1999 46.5 71.3999 46.8 71.3999C47.8 71.4999 48.8 71.4999 49.9 71.5999C50 71.9999 50 72.3999 50.1 72.7999C50.4 72.8999 50.8 72.8999 51.3 72.9999C51.3 74.5999 51.4 76.1999 51.2 77.7999C51.2 78.0999 50.5 78.2999 49.9 78.6999C49.9 78.7999 49.8 79.1999 49.8 79.5999C49.4 79.6999 49.1 79.6999 48.6 79.7999C48.5 80.1999 48.4 80.5999 48.3 81.0999C47.1 81.0999 45.8 81.0999 44.5 81.0999C44.4 80.6999 44.3 80.2999 44.2 79.7999C43.8 79.6999 43.5 79.6999 43 79.5999C42.9 79.1999 42.8 78.7999 42.8 78.5999C41.9 77.8999 40 79.1999 40.1 76.9999C40 76.8999 39.6 76.8999 39.1 76.7999Z"
          fill="#00FF00"
        />
        <path
          d="M83.9 65.8998C86.3 65.8998 88.7 65.8998 91 65.8998C91.6 65.8998 92.1 65.7998 92.2 66.6998C92.2 66.8998 92.6 67.1998 92.9 67.1998C93.5 67.2998 94.1 67.2998 94.7 67.3998C94.8 67.7998 94.9 68.1998 95 68.6998C95.4 68.6998 95.7 68.7998 96.2 68.8998C96.2 69.2998 96.2 69.5998 96.2 69.9998C95.7 70.0998 95.4 70.0998 94.9 70.1998C94.8 70.8998 94.9 71.6998 93.8 71.6998C93.7 71.6998 93.6 71.7998 93.6 71.7998C93.5 73.3998 92.2 72.7998 91.4 72.8998C89.4 72.9998 87.4 72.8998 85.2 72.8998C85.2 71.3998 84.2 71.4998 83.2 71.4998C81.5 71.4998 79.8 71.4998 78 71.4998C77.9 71.9998 77.9 72.2998 77.8 72.7998C77.4 72.8998 77 72.8998 76.6 72.9998C76.5 73.3998 76.4 73.7998 76.4 74.1998C75.9 74.2998 75.4 74.2998 74.9 74.3998C74.3 74.3998 73.9 74.4998 73.7 75.1998C73.6 75.4998 73 75.6998 72.4 76.0998C72.4 76.1998 72.3 76.5998 72.2 76.9998C71.9 77.0998 71.5 77.0998 71 77.1998C70.9 77.5998 70.8 77.9998 70.7 78.3998C70.3 78.4998 69.9 78.4998 69.5 78.5998C69.4 78.9998 69.4 79.3998 69.3 79.7998C68.9 79.8998 68.5 79.8998 68.1 79.9998C68 80.3998 67.9 80.7998 67.8 81.2998C66.1 81.2998 64.4 81.2998 62.6 81.2998C62.5 80.3998 62.5 79.4998 62.4 78.5998C62 78.4998 61.6 78.4998 61.1 78.3998C61.1 76.5998 61.1 74.8998 61.1 73.0998C61.5 72.9998 61.9 72.9998 62.3 72.8998C62.4 72.4998 62.4 72.0998 62.5 71.6998C63.4 71.6998 64.2 71.5998 65.1 71.5998C65.2 71.1998 65.2 70.7998 65.3 70.3998C66.3 70.2998 67.4 70.2998 68.4 70.1998C68.7 70.1998 69.1 69.9998 69.2 69.7998C69.3 68.7998 70.1 68.8998 70.7 68.8998C72 68.7998 72 68.7998 72.4 67.4998C73.6 67.4998 74.9 67.4998 76.2 67.4998C76.3 66.9998 76.4 66.6998 76.5 66.0998C77.7 66.0998 79 66.0998 80.4 66.0998C80.5 65.5998 80.6 65.1998 80.7 64.7998C81.5 64.7998 82.3 64.7998 83.1 64.7998C83.6 64.8998 83.7 65.2998 83.9 65.8998Z"
          fill="#00FF00"
        />
        <path
          d="M30.6 121.7C29.7 121.7 28.9 121.6 28 121.6C27.9 121.2 27.8 120.8 27.7 120.3C27.3 120.3 27 120.2 26.5 120.1C26.5 118.4 26.5 116.6 26.5 114.9C26.9 114.8 27.2 114.8 27.8 114.6C27.8 112.9 27.8 111.1 27.8 109.3C28.3 109.2 28.7 109.1 29.2 109C29.2 107.3 29.2 105.5 29.2 103.7C29.7 103.6 30.1 103.5 30.6 103.4C30.6 102.6 30.6 101.8 30.6 101.3C31.3 100.6 31.8 100.2 32.3 99.7C32.2 99.6 32.2 99.5 32.1 99.4C32.9 99.3 33.8 99.3 34.6 99.2C34.7 98.8 34.8 98.4 34.8 98C37 98 39.2 98 41.5 98C41.5 99.3 41.5 100.5 41.5 101.8C41.1 101.9 40.7 102 40.2 102.1C40.2 102.9 40.2 103.8 40.2 104.6C39.7 104.7 39.3 104.8 38.8 104.9C38.8 106.2 38.8 107.5 38.8 108.8C38.3 108.9 37.9 108.9 37.4 109C37.4 110.3 37.4 111.6 37.4 113C36.1 113 36 113.7 36 114.6C36 116.9 35.9 119.3 36 121.6C36 122.7 35.7 122.9 34.7 122.8C33.8 122.7 32.9 122.7 32 122.8C31.2 123.1 30.5 123 30.6 121.7Z"
          fill="#00FF00"
        />
        <path
          d="M83.6 110.6C85 110.5 85 111.3 85 112.2C85 113.5 85 114.8 85 116.1C85.5 116.2 85.8 116.3 86.3 116.3C86.3 117.1 86.3 117.9 86.3 118.7C86 118.8 85.6 118.9 85.2 118.9C85.1 119.2 85.1 119.6 85 120.1C84.7 120.2 84.3 120.2 83.8 120.3C83.7 120.6 83.6 121 83.5 121.5C83 121.6 82.5 121.6 82 121.7C81.4 121.7 80.9 121.8 80.9 122.5C80.9 122.7 80.5 123 80.3 123C79.2 123 78.1 123 76.9 123C76.9 120.7 76.9 118.5 76.9 116.1C75.5 116.1 75.4 115.3 75.4 114.3C75.5 113.1 75.4 111.8 75.4 110.5C74.9 110.4 74.5 110.4 74 110.3C74 109 74 107.7 74 106.4C73.5 106.3 73.1 106.2 72.7 106.2C72.6 105.2 72.6 104.2 72.5 103.2C72.5 102.9 72.4 102.5 72.3 102.4C70.5 102 71.4 100.5 71.1 99.5C71.1 99.5 71.1 99.4 71 99.3C70.7 99.3 70.3 99.2 69.9 99.1C69.9 98.8 69.9 98.4 69.8 98C72.5 98 75.2 98 77.9 98C78 98.4 78 98.8 78.1 99.2C78.9 99.2 79.8 99.3 80.7 99.3C80.8 99.7 80.8 100.1 80.9 100.5C81.3 100.6 81.6 100.6 82.2 100.7C82.2 101.8 82.1 102.9 82.2 104C82.3 104.8 81.9 106 83.3 106.2C83.4 106.2 83.5 106.7 83.6 107C83.7 108.3 83.6 109.4 83.6 110.6Z"
          fill="#00FF00"
        />
        <path
          d="M37.4 85.4001C37.4 85.9001 37.4 86.2001 37.4 86.6001C37 86.7001 36.7 86.8001 36.1 86.9001C36.1 87.7001 36 88.5001 36 89.4001C35.6 89.5001 35.2 89.5001 34.8 89.6001C34.7 90.0001 34.7 90.4001 34.6 90.8001C33.5 91.1001 33.5 91.1001 33.2 93.6001C32.9 93.7001 32.5 93.7001 32 93.8001C32 94.6001 32 95.4001 32 96.4001C31.5 96.4001 31.2 96.4001 30.8 96.5001C30.7 96.0001 30.7 95.6001 30.6 95.2001C30.2 95.1001 29.8 95.1001 29.4 95.0001C29.3 94.6001 29.3 94.2001 29.2 93.8001C28.8 93.7001 28.4 93.7001 28 93.6001C27.9 93.2001 27.9 92.8001 27.8 92.4001C27.4 92.3001 27.1 92.3001 26.6 92.2001C26.5 91.8001 26.5 91.5001 26.4 91.0001C26 90.9001 25.6 90.8001 25.1 90.7001C25.1 89.9001 25 89.0001 25 88.2001C24.6 88.1001 24.2 88.1001 23.8 88.0001C23.7 87.4001 23.7 86.7001 23.6 86.1001C23.6 85.9001 23.4 85.5001 23.2 85.5001C22.2 85.4001 22.3 84.7001 22.2 84.0001C21 84.0001 19.7 84.0001 18.5 84.0001C18.3 84.0001 18 84.5001 18 84.7001C17.9 85.3001 17.9 85.9001 17.9 86.6001C17.5 86.6001 17.2 86.6001 16.7 86.7001C16.7 85.7001 16.7 84.9001 16.7 84.0001C16.2 83.9001 15.8 83.9001 15.4 83.8001C15.3 82.8001 15.3 81.8001 15.2 80.8001C15.2 80.5001 15.1 80.1001 15 80.0001C13.3 79.6001 14 78.2001 13.8 77.2001C13.8 77.1001 13.7 77.1001 13.7 76.9001C13.4 76.8001 13 76.8001 12.6 76.7001C12.6 76.4001 12.5 76.1001 12.5 75.9001C12.5 70.5001 12.5 65.2001 12.5 59.8001C12.5 59.0001 12.6 58.5001 13.7 58.9001C13.7 59.7001 13.7 60.5001 13.7 61.4001C14.2 61.5001 14.6 61.5001 15.1 61.6001C15.1 63.3001 15.1 65.0001 15.1 66.8001C14.7 66.9001 14.3 67.0001 13.9 67.1001C13.9 68.9001 13.9 70.7001 13.9 72.6001C14.3 72.7001 14.6 72.7001 15 72.8001C15 72.9001 15.1 73.0001 15.1 73.1001C15.3 75.5001 15.3 75.5001 17.7 75.5001C18.2 75.5001 18.6 75.5001 19.1 75.5001C19.2 76.0001 19.3 76.4001 19.4 76.9001C20.2 76.9001 21.1 76.9001 21.9 76.9001C22 77.4001 22 77.8001 22.1 78.2001C22.5 78.3001 22.9 78.3001 23.3 78.4001C23.4 78.8001 23.4 79.1001 23.5 79.6001C23.9 79.7001 24.3 79.8001 24.7 79.8001C24.8 80.2001 24.8 80.5001 24.9 81.0001C25.3 81.1001 25.7 81.1001 26.1 81.2001C26.2 83.2001 27.8 82.2001 28.9 82.6001C29 83.0001 29 83.4001 29.1 83.8001C29.5 83.8001 29.9 83.9001 30.3 84.0001C30.4 84.4001 30.4 84.8001 30.5 85.3001C32.8 85.4001 35.1 85.4001 37.4 85.4001Z"
          fill="#00FF00"
        />
        <path
          d="M85.1 92.3999C85.1 92.7999 85 93.1999 84.9 93.5999C84.5 93.6999 84.1 93.6999 83.7 93.7999C83.6 94.1999 83.6 94.4999 83.5 94.9999C83.1 95.0999 82.7 95.1999 82.3 95.1999C82.3 95.5999 82.2 95.8999 82.2 96.3999C81.8 96.3999 81.5 96.3999 81.1 96.4999C81 95.8999 81 95.3999 80.9 94.7999C80.8 94.4999 80.7 93.8999 80.5 93.8999C79.6 93.7999 79.5 93.1999 79.6 92.3999C79.2 92.2999 78.8 92.1999 78.3 92.0999C78.2 91.2999 78.2 90.3999 78.1 89.5999C77.6 89.4999 77.3 89.3999 76.9 89.3999C76.8 88.9999 76.8 88.5999 76.8 88.1999C76.4 88.0999 76 88.0999 75.6 87.9999C75.6 87.1999 75.6 86.3999 75.6 85.4999C77.8 85.4999 80.1 85.4999 82.3 85.4999C82.4 84.9999 82.5 84.5999 82.5 84.1999C82.9 84.0999 83.3 84.0999 83.7 83.9999C83.8 83.5999 83.8 83.2999 83.9 82.7999C84.3 82.6999 84.7 82.6999 85.1 82.5999C85.1 82.1999 85.2 81.8999 85.3 81.3999C85.8 81.2999 86.4 81.1999 86.9 81.1999C87.4 81.1999 87.8 81.0999 88 80.3999C88.1 79.9999 88.8 79.8999 89.4 79.4999C89.4 79.3999 89.5 78.9999 89.6 78.5999C90 78.4999 90.4 78.4999 90.8 78.3999C90.9 77.9999 90.9 77.6999 91 77.1999C91.8 77.0999 92.6 77.0999 93.5 76.9999C93.6 76.5999 93.7 76.1999 93.8 75.6999C94.6 75.6999 95.5 75.6999 96.4 75.6999C96.5 75.1999 96.5 74.7999 96.6 74.3999C97 74.2999 97.4 74.2999 97.9 74.1999C97.9 73.5999 97.8 72.8999 97.9 72.2999C97.9 71.9999 98.3 71.6999 98.5 71.3999C98.7 71.6999 99.1 71.8999 99.1 72.1999C99.1 74.5999 99.1 77.0999 99.1 79.5999C98.6 79.6999 98.2 79.7999 97.7 79.8999C97.7 80.6999 97.7 81.5999 97.7 82.3999C97.2 82.4999 96.8 82.4999 96.4 82.5999C96.4 83.3999 96.3 84.2999 96.3 85.1999C95.7 85.3999 94.8 85.2999 94.9 86.3999C94.9 86.4999 94.4 86.7999 94.3 86.6999C94.1 86.5999 93.8 86.2999 93.8 86.0999C93.7 85.4999 93.8 84.7999 93.8 84.0999C92.7 84.0999 91.8 84.0999 90.9 84.0999C90.8 84.4999 90.8 84.8999 90.7 85.2999C90.3 85.3999 89.9 85.3999 89.5 85.4999C89.5 86.2999 89.4 87.1999 89.4 88.0999C89 88.1999 88.6 88.1999 88.2 88.2999C88.1 88.6999 88.1 89.0999 88 89.4999C87.6 89.5999 87.3 89.5999 86.8 89.6999C86.8 90.4999 86.7 91.2999 86.7 92.1999C86 92.1999 85.6 92.2999 85.1 92.3999Z"
          fill="#00FF00"
        />
        <path
          d="M8.29999 97.8C8.29999 96.7 8.29999 95.7 8.29999 94.7C8.29999 93.8 8.69999 93.7 9.49999 93.9C9.59999 94.2 9.59999 94.6 9.69999 95.1C10.1 95.2 10.5 95.3 10.9 95.4C10.9 95.8 11 96.2 11.1 96.6C11.5 96.7 11.9 96.7 12.2 96.8C13 97.6 11.5 99.5 13.6 99.6C14 101.2 15.3 100.9 16.5 101C16.6 101.4 16.7 101.8 16.8 102.3C17.4 102.4 18.2 102.3 18.3 103.3C18.3 103.5 18.9 103.6 19.3 103.7C19.7 103.8 20.2 103.8 20.7 103.9C20.8 104.3 20.8 104.6 20.9 105.1C21.6 105.2 22.2 105.3 22.6 106.2C22.8 106.6 24.1 106.6 24.9 106.8C24.9 108.5 24.9 110.2 24.9 112C24.5 112.1 24.1 112.1 23.6 112.2C23.6 113.5 23.6 114.8 23.6 116.2C23.1 116.2 22.8 116.2 22.4 116.3C22.3 115.8 22.3 115.5 22.2 115C21.4 115 20.5 114.9 19.6 114.9C19.5 114.5 19.5 114.1 19.4 113.7C19 113.6 18.6 113.5 18.2 113.5C18.1 113.1 18.1 112.8 18 112.3C17.6 112.2 17.2 112.2 16.8 112.1C16.7 111.7 16.7 111.3 16.6 110.9C16.2 110.8 15.8 110.7 15.4 110.7C15.3 110.2 15.3 109.7 15.2 109.2C15.2 108.6 15.1 108.2 14.4 108C14.1 107.9 13.9 107.3 13.6 106.7C13.5 106.7 13.2 106.6 12.7 106.5C12.6 106.1 12.6 105.7 12.5 105.3C12.1 105.2 11.8 105.2 11.3 105.1C11.2 104.7 11.2 104.3 11.1 103.9C9.79999 104 9.69999 103.1 9.79999 102.1C9.89999 100.9 9.79999 99.6 9.79999 98.3C9.19999 97.9 8.79999 97.9 8.29999 97.8Z"
          fill="#00FF00"
        />
        <path
          d="M103.2 95.1001C103.2 96.9001 103.2 98.7001 103.2 100.5C101.7 100.5 101.8 101.5 101.8 102.5C101.8 103 101.8 103.5 101.1 103.6C100.9 103.6 100.6 104 100.6 104.3C100.5 104.9 100.5 105.5 100.4 106.1C100 106.2 99.6 106.3 99.1 106.4C99.1 106.8 99 107.1 98.9 107.6C98.5 107.7 98.1 107.7 97.7 107.8C97.6 108.2 97.5 108.6 97.5 109C95.4 109 96.6 110.8 96 111.8C95.7 111.8 95.3 111.9 94.9 112C94.8 112.4 94.8 112.7 94.7 113.1C93.9 113.8 92 112.5 91.9 114.5C89.5 114.9 89.5 114.9 89.1 113.4C88.8 113.3 88.4 113.3 87.9 113.2C87.9 111 87.9 108.8 87.9 106.6C88.3 106.5 88.7 106.5 89.1 106.4C89.2 106 89.2 105.7 89.3 105.1C89.9 105.1 90.5 105.1 91.1 105C91.6 104.9 91.9 104.4 92.3 104.1C92.2 104 92.2 103.9 92.1 103.8C92.5 103.7 92.8 103.7 93.3 103.6C93.4 103.2 93.4 102.9 93.5 102.3C94.1 102.3 94.7 102.3 95.3 102.2C95.8 102.1 96.1 101.6 96.5 101.3C96.4 101.2 96.4 101.1 96.3 101C96.7 100.9 97 100.9 97.5 100.8C97.6 100.4 97.6 100.1 97.7 99.6001C98.1 99.5001 98.5 99.5001 98.9 99.4001C98.9 99.0001 99 98.7001 99 98.2001C99.4 98.1001 99.8 98.1001 100.2 98.0001C100.3 97.6001 100.3 97.2001 100.4 96.8001C100.8 96.7001 101.2 96.7001 101.6 96.6001C101.7 96.2001 101.7 95.8001 101.8 95.3001C102.5 95.2001 102.9 95.2001 103.2 95.1001Z"
          fill="#00FF00"
        />
        <path
          d="M51.2 106C48.8 106.5 48.8 106.5 48.8 104C48.8 103.5 48.8 102.9 48.8 102.4C49.3 102.3 49.7 102.3 50.1 102.2C50.1 101.4 50.2 100.5 50.2 99.5999C50.6 99.4999 51 99.3999 51.5 99.2999C51.5 97.9999 51.5 96.7999 51.5 95.3999C52 95.2999 52.4 95.2999 52.9 95.1999C52.8 93.9999 53.5 93.7999 54.5 93.8999C55.8 93.9999 57.1 93.9999 58.5 93.8999C59.6 93.7999 60 94.1999 59.9 95.2999C59.9 95.6999 59.9 96.0999 60 96.5999C60.4 96.6999 60.8 96.6999 61.3 96.7999C61.3 97.7999 61.4 98.7999 61.4 99.7999C61.4 100.1 61.5 100.5 61.6 100.6C63.4 101 62.5 102.5 62.8 103.5C62.8 103.5 62.8 103.6 62.9 103.7C63.2 103.7 63.6 103.8 64 103.9C64 104.7 64 105.5 64 106.4C63.3 106.4 62.6 106.4 61.9 106.4C61.7 106.4 61.4 106.2 61.4 106.1C61.3 105.1 60.6 105.1 60 105.1C57.4 105.1 54.9 105 52.3 105.1C51.9 105 51.6 105.6 51.2 106Z"
          fill="#00FF00"
        />
        <path
          d="M90.7 89.7002C91.2 89.7002 91.5 89.7002 91.9 89.7002C91.9 92.9002 91.9 95.9002 91.9 99.1002C91.5 99.2002 91.1 99.3002 90.7 99.4002C90.6 99.8002 90.6 100.1 90.5 100.5C89.6 101.2 87.7 99.9002 87.7 101.9C87.6 102 87.6 102 87.5 102C85.1 102.3 85.1 102.3 85.1 99.9002C85.1 98.9002 85.1 97.8002 85.1 96.9002C86.1 96.2002 87.8 97.4002 88 95.4002C89.8 95.2002 89.2 93.7002 89.4 92.6002C89.8 92.5002 90.2 92.4002 90.7 92.3002C90.7 91.5002 90.7 90.7002 90.7 89.7002Z"
          fill="#00FF00"
        />
        <path
          d="M23.8 102C23.7 101.6 23.7 101.2 23.6 100.8C23.2 100.8 22.8 100.7 22.4 100.6C22.3 100.2 22.2 99.9 22.2 99.4C21.9 99.3 21.5 99.3 20.9 99.1C20.9 98.3 20.9 97.4 20.9 96.5C20.9 95.6 20.9 94.8 19.6 95C19.5 94.3 19.3 93.8 20.2 93.7C20.4 93.7 20.7 93.3 20.8 93C20.9 92.4 20.9 91.8 21 91.1C21.4 91.1 21.7 91 22.1 91C22.2 91.6 22.2 92.2 22.4 92.6C22.5 93 22.9 93.3 23.2 93.7C23.5 94.1 23.7 94.5 24 95.1C24.2 95.1 24.5 95.2 25 95.2C25.1 95.6 25.1 95.9 25.2 96.5C26 96.5 26.8 96.6 27.8 96.6C27.8 97.9 27.8 99.1 27.8 100.5C27.5 100.6 27.1 100.6 26.7 100.7C26.1 102.2 26.1 102.2 23.8 102Z"
          fill="#00FF00"
        />
        <path
          d="M96.5 64.6C96.9 64.5 97.3 64.4 97.8 64.3C97.8 63 97.8 61.7 97.8 60.4C98.4 60.3 99 60 99 61C99 63.4 99 65.9 99 68.4C98.6 68.4 98.2 68.4 97.8 68.4C97.7 67.7 97.7 67.1 97.6 66.5C97.5 66.2 97.3 65.8 97 65.8C96.2 65.7 96.4 65.2 96.5 64.6Z"
          fill="#00FF00"
        />
        <path
          d="M81 78.5C80.9 78.9 80.8 79.2 80.7 79.7C79.9 79.7 79 79.7 78.1 79.7C78.1 80.2 78 80.6 78 81C77.2 81 76.4 81 75.5 81C75.5 80.7 75.5 80.3 75.5 80C76 79.9 76.3 79.9 76.8 79.8C76.9 79.4 76.9 79.1 77 78.5C78.3 78.5 79.6 78.5 81 78.5Z"
          fill="#00FF00"
        />
        <path
          d="M34.7 79.7998C33.9 79.6998 33 79.6998 32.1 79.5998C32.1 79.1998 32 78.6998 32 78.2998C32.8 78.2998 33.7 78.2998 34.7 78.2998C34.7 78.9998 34.7 79.3998 34.7 79.7998Z"
          fill="#00FF00"
        />
        <path
          d="M32 78.4002C31.3 78.4002 30.6 78.4002 29.9 78.3002C29.7 78.3002 29.5 77.9002 29.3 77.7002C29.5 77.5002 29.7 77.2002 29.9 77.2002C30.5 77.1002 31.1 77.2002 31.8 77.2002C31.9 77.6002 31.9 78.0002 32 78.4002Z"
          fill="#00FF00"
        />
        <path
          d="M45.8 100.8C45.8 101.7 45.8 102.5 45.8 103.4C45.4 103.4 45.1 103.5 44.7 103.5C44.7 102.6 44.7 101.8 44.7 100.9C45.1 100.9 45.4 100.9 45.8 100.8Z"
          fill="#00FF00"
        />
        <path
          d="M68.3 104.9C67.9 104.9 67.5 104.8 67.1 104.8C67.1 104 67.1 103.2 67.1 102.3C67.4 102.3 67.8 102.3 68.3 102.2C68.3 103.2 68.3 104.1 68.3 104.9Z"
          fill="#00FF00"
        />
        <path
          d="M68.3 104.9C68.7 105 69.1 105 69.7 105.1C69.7 105.8 69.8 106.4 69.7 107C69.7 107.2 69.3 107.4 69.1 107.6C68.9 107.4 68.5 107.2 68.5 107C68.3 106.4 68.4 105.6 68.3 104.9Z"
          fill="#00FF00"
        />
        <path
          d="M57.1 78.4002C57.9 78.4002 58.8 78.3002 58.3 79.6002C57.1 80.0002 57.1 79.2002 57.1 78.4002C57.2 78.4002 57.1 78.4002 57.1 78.4002Z"
          fill="#00FF00"
        />
        <path
          d="M34.7 79.7998C36.1 79.7998 36.1 79.7998 36 80.9998C35.7 80.9998 35.3 80.9998 34.9 81.0998C34.9 80.5998 34.8 80.1998 34.7 79.7998Z"
          fill="#00FF00"
        />
        <path
          d="M81 78.5002C80.9 77.7002 80.7 76.8002 82.2 77.2002C82.2 77.5002 82.2 77.8002 82.2 78.2002C81.8 78.3002 81.4 78.4002 81 78.5002Z"
          fill="#00FF00"
        />
        <path
          d="M65.7 99.4998C66.7 99.1998 67 99.5998 66.8 100.6C66.5 100.6 66.1 100.6 65.7 100.7C65.7 100.3 65.7 99.8998 65.7 99.4998Z"
          fill="#00FF00"
        />
        <path
          d="M42.9 105.6C43.4 105.3 43.7 105 44 105C44.2 105 44.5 105.5 44.5 105.7C44.5 106 44.1 106.3 43.9 106.4C43.6 106.3 43.4 106 42.9 105.6Z"
          fill="#00FF00"
        />
        <path
          d="M43 109C42.6 109 42.3 109 41.9 109C41.9 108.6 41.9 108.3 41.9 107.9C42.2 107.9 42.6 107.9 43 107.8C43 108.3 43 108.6 43 109Z"
          fill="#00FF00"
        />
        <path
          d="M69.9 110.4C69.9 110 69.9 109.7 69.9 109.3C70.3 109.3 70.6 109.3 71 109.3C71.2 110.2 71 110.7 69.9 110.4Z"
          fill="#00FF00"
        />
        <path
          d="M45.9 25.2002C47.4 25.2002 48.7 25.2002 50.1 25.2002C50.1 26.6002 50.1 27.9002 50.1 29.5002C48.9 29.5002 47.7 29.5002 46.5 29.5002C46.3 29.5002 45.9 29.1002 45.9 28.9002C45.9 27.7002 45.9 26.5002 45.9 25.2002Z"
          fill="black"
        />
        <path
          d="M58.6 22.5002C57.1 22.5002 55.8 22.5002 54.4 22.5002C54.4 21.1002 54.4 19.7002 54.4 18.2002C55.7 18.2002 56.9 18.2002 58.1 18.2002C58.3 18.2002 58.6 18.6002 58.6 18.8002C58.6 20.0002 58.6 21.2002 58.6 22.5002Z"
          fill="black"
        />
        <path
          d="M62.7 34.9998C62.7 33.5998 62.7 32.2998 62.7 30.7998C64 30.7998 65.2 30.7998 66.5 30.7998C66.7 30.7998 66.8 31.0998 66.9 31.1998C67 31.2998 66.9 31.3998 66.9 31.4998C67.3 35.1998 67 35.3998 62.7 34.9998Z"
          fill="black"
        />
        <path
          d="M46 18.2998C47.3 18.2998 48.7 18.2998 50.2 18.2998C50.2 19.6998 50.2 20.9998 50.2 22.4998C48.8 22.4998 47.5 22.4998 46.1 22.4998C46 20.9998 46 19.5998 46 18.2998Z"
          fill="black"
        />
        <path
          d="M58.6 35.0998C57.1 35.0998 55.8 35.0998 54.4 35.0998C54.4 33.6998 54.4 32.3998 54.4 30.7998C55.6 30.7998 56.8 30.7998 58.1 30.7998C58.3 30.7998 58.6 31.1998 58.6 31.2998C58.6 32.5998 58.6 33.7998 58.6 35.0998Z"
          fill="black"
        />
        <path
          d="M50.2 35.0999C48.8 35.0999 47.5 35.0999 46 35.0999C46 33.6999 46 32.3999 46 30.8999C47.4 30.8999 48.7 30.8999 50.2 30.8999C50.2 32.1999 50.2 33.5999 50.2 35.0999Z"
          fill="black"
        />
        <path
          d="M62.7 29.4998C62.7 27.9998 62.7 26.6998 62.7 25.2998C64.1 25.2998 65.4 25.2998 66.9 25.2998C66.9 26.4998 66.9 27.7998 66.9 28.9998C66.9 29.1998 66.5 29.4998 66.2 29.4998C65.1 29.4998 64 29.4998 62.7 29.4998Z"
          fill="black"
        />
        <path
          d="M54.3 29.4998C54.3 27.9998 54.3 26.6998 54.3 25.2998C55.7 25.2998 57 25.2998 58.6 25.2998C58.6 26.4998 58.6 27.6998 58.6 28.8998C58.6 29.0998 58.3 29.3998 58.1 29.3998C56.8 29.4998 55.7 29.4998 54.3 29.4998Z"
          fill="black"
        />
        <path
          d="M58.6 128.8C56.8 128.8 55.2 128.8 53.5 128.8C53.3 128.8 52.9 128.4 52.9 128.2C52.9 122.8 52.9 117.4 52.9 112C54 112.1 54.4 111.6 54.3 110.6C55.6 110.6 56.8 110.6 58 110.6C58.2 110.6 58.6 111.1 58.6 111.3C58.6 117 58.6 122.8 58.6 128.8Z"
          fill="black"
        />
        <path
          d="M61.3 113.3C63.1 113.3 64.7 113.3 66.2 113.3C66.5 113.3 66.9 113.8 66.9 114C66.9 118.4 66.9 122.8 66.9 127.3C66 127.3 65.2 127.4 64.3 127.4C64.2 127.8 64.1 128.2 64 128.6C63.9 128.6 63.8 128.7 63.8 128.7C61.3 129 61.2 128.8 61.2 126.4C61.2 122.5 61.2 118.6 61.2 114.6C61.3 114.3 61.3 113.9 61.3 113.3Z"
          fill="black"
        />
        <path
          d="M50.2 128.7C49.7 128.7 49.3 128.7 48.8 128.7C48.9 127.4 48.1 127.4 47.2 127.4C44.4 127.3 44.6 127.7 44.6 124.7C44.5 121.8 44.6 119 44.6 116.1C44.6 115.7 44.6 115.3 44.6 114.8C45.1 114.7 45.5 114.7 45.9 114.6C46 114.2 46 113.8 46.1 113.4C47.5 113.4 48.8 113.4 50.3 113.4C50.2 118.5 50.2 123.5 50.2 128.7Z"
          fill="black"
        />
        <path d="M69.9 79.7002H63V81.3002H69.9V79.7002Z" fill="#00FF00" />
        <path d="M71.8 81.2998H70.2V82.8998H71.8V81.2998Z" fill="#00FF00" />
        <path d="M73.7 82.8999H72.1V84.4999H73.7V82.8999Z" fill="#00FF00" />
        <path d="M75.6 84.3999H74V85.9999H75.6V84.3999Z" fill="#00FF00" />
        <path d="M77.4 86H75.8V87.6H77.4V86Z" fill="#00FF00" />
        <path d="M71.2 78.2998H66.8V79.8998H71.2V78.2998Z" fill="#00FF00" />
        <path d="M96.4 71H69.7V81.3H96.4V71Z" fill="#00FF00" />
        <path d="M86.9 79.7002H71.3V82.9002H86.9V79.7002Z" fill="#00FF00" />
        <path d="M86.9 81.2998H72.9V84.4998H86.9V81.2998Z" fill="#00FF00" />
        <path d="M83.9 83.7002H75.4V86.1002H83.9V83.7002Z" fill="#00FF00" />
        <path d="M98.3 69.2002H94V75.3002H98.3V69.2002Z" fill="#00FF00" />
        <path
          d="M45.3 80.5V82.9H43.7V84H42V85.3H38.4H37L33.4 86.9L19.5 79.7L14.3 75L16.8 70.6L27.7 67C27.7 67 39.2 70 39.6 71.1C39.9 72.1 45.3 80.5 45.3 80.5Z"
          fill="#00FF00"
        />
        <path
          d="M46.2 132.3C47.1 132.3 48 132.3 48.9 132.3C49.6 132.3 50.4 132.1 50.6 133.2C50.6 133.4 51.2 133.5 51.5 133.5C55 133.5 58.6 133.5 62.1 133.5C62.4 133.5 62.8 133.4 62.8 133.3C63.1 131.7 64.4 132.3 65.4 132.2C65.5 132.2 65.6 132.2 65.8 132.1C65.7 130.6 66.8 130.7 67.7 130.8C68 130.8 68.3 131.2 68.6 131.4C68.3 131.6 68 131.9 67.7 132C67.6 132.1 67.4 132.1 67.2 132.1C67.1 132.5 67.1 132.9 67 133.4C66.2 133.4 65.3 133.5 64.4 133.5C64.3 133.9 64.2 134.3 64.1 134.8C59.1 134.8 54.2 134.8 49.1 134.8C49 134.4 48.9 134 48.8 133.6C48 133.6 47.2 133.5 46.3 133.5C46.4 133.1 46.3 132.7 46.2 132.3Z"
          fill="#00FF00"
        />
        <path
          d="M46.3 132.3C45.5 132.2 44.6 132.2 43.7 132.1C43.7 131.7 43.7 131.4 43.7 131C44.5 131 45.3 131 46.2 131C46.2 131.4 46.2 131.9 46.3 132.3C46.2 132.3 46.3 132.3 46.3 132.3Z"
          fill="#00FF00"
        />
        <path
          d="M46.9 71.3999L47.3 79.8999H51.4L55.6 79.3999L58.3 79.6999L61.4 79.7999L65.6 79.9999L73.6 69.2999C73.6 69.2999 96.5 69.1999 94 69.2999C91.5 69.3999 92 58.8999 92 58.8999L48.9 52.3999L19.5 57.9999L18.2 68.3999L46.9 71.3999Z"
          fill="#00FF00"
        />
        <path
          d="M12.5 59.6002L13.1 58.3002L15.4 57.6002L16.8 56.2002L21.7 57.6002L19.6 72.3002L14.3 75.9002L12.6 73.5002"
          fill="#00FF00"
        />
        <path
          d="M94.9 54.7998L94.3 57.5998H95.7L96.4 57.9998V59.2998H97.7V60.3998C97.7 60.3998 97.7 62.8998 97.7 62.9998C97.7 63.0998 98.3 62.7998 97.7 64.2998C97.1 65.7998 98.1 66.6998 98 67.4998C97.9 68.2998 98.3 69.1998 98.3 69.1998C98.4 71.2998 99.4 72.0998 97.8 72.1998C96.2 72.2998 94.2 71.8998 92 69.7998C89.7 67.6998 89.4 66.3998 89.7 65.1998C90 63.9998 91 57.6998 91 57.6998"
          fill="#00FF00"
        />
        <path d="M82.9 62.7002H81.5V65.1002H82.9V62.7002Z" fill="black" />
        <path d="M81.9 63.9004H80.5V66.3004H81.9V63.9004Z" fill="black" />
        <path d="M84.2 65H79.8V67.7H84.2V65Z" fill="black" />
        <path d="M81.2 67H79.8V69.4H81.2V67Z" fill="black" />
        <path d="M84.2 67.7002H79.8V71.0002H84.2V67.7002Z" fill="black" />
        <path d="M81.9 69.2002H80.5V71.6002H81.9V69.2002Z" fill="black" />
        <path d="M82.6 70.2002H81.2V72.6002H82.6V70.2002Z" fill="black" />
        <path d="M83.4 70.7002H82V73.1002H83.4V70.7002Z" fill="black" />
        <path d="M83.7 70.4004H82.3V72.8004H83.7V70.4004Z" fill="black" />
        <path d="M84.4 70.1001H83V72.5001H84.4V70.1001Z" fill="black" />
        <path d="M85.1 68.9004H83.7V71.3004H85.1V68.9004Z" fill="black" />
        <path d="M85.3 67.7002H83.9V70.1002H85.3V67.7002Z" fill="black" />
        <path d="M85.3 65.9004H83.9V68.3004H85.3V65.9004Z" fill="black" />
        <path d="M85 65H83.6V67.4H85V65Z" fill="black" />
        <path d="M84.6 64.2002H83.2V66.6002H84.6V64.2002Z" fill="black" />
        <path d="M84.5 63.2002H82.4V65.4002H84.5V63.2002Z" fill="black" />
        <path
          d="M83.94 69.8591L85.03 69.7109L84.801 68.0264L83.711 68.1746L83.94 69.8591Z"
          fill="black"
        />
        <path
          d="M84.215 68.344L85.305 68.1958L85.076 66.5113L83.986 66.6594L84.215 68.344Z"
          fill="black"
        />
        <path
          d="M83.7322 68.6448L84.8221 68.4966L84.5932 66.8121L83.5032 66.9602L83.7322 68.6448Z"
          fill="black"
        />
        <path
          d="M83.0599 67.8972L84.1499 67.749L83.9209 66.0645L82.8309 66.2127L83.0599 67.8972Z"
          fill="black"
        />
        <path
          d="M83.5998 67.4734L84.6898 67.3252L84.4608 65.6407L83.3708 65.7888L83.5998 67.4734Z"
          fill="black"
        />
        <path
          d="M83.5518 66.5632L84.6418 66.415L84.4128 64.7305L83.3228 64.8787L83.5518 66.5632Z"
          fill="black"
        />
        <path
          d="M82.9211 66.6321L84.011 66.4839L83.7821 64.7994L82.6921 64.9475L82.9211 66.6321Z"
          fill="black"
        />
        <path
          d="M82.1672 67.1135L83.2571 66.9653L83.0282 65.2808L81.9382 65.429L82.1672 67.1135Z"
          fill="black"
        />
        <path
          d="M82.0787 66.1555L83.1687 66.0073L82.9397 64.3228L81.8497 64.471L82.0787 66.1555Z"
          fill="black"
        />
        <path
          d="M81.1966 64.4001L82.2866 64.252L82.0576 62.5674L80.9676 62.7156L81.1966 64.4001Z"
          fill="black"
        />
        <path
          d="M81.8051 64.9719L82.8951 64.8237L82.6661 63.1392L81.5761 63.2874L81.8051 64.9719Z"
          fill="black"
        />
        <path
          d="M80.5655 65.964L82.6464 65.6812L82.1884 62.3121L80.1076 62.595L80.5655 65.964Z"
          fill="black"
        />
        <path
          d="M80.3462 65.1711L81.4362 65.0229L81.2072 63.3384L80.1172 63.4866L80.3462 65.1711Z"
          fill="black"
        />
        <path
          d="M80.6807 62.0347L79.6898 62.1694L79.9188 63.854L80.9097 63.7193L80.6807 62.0347Z"
          fill="black"
        />
        <path
          d="M80.486 62.5318L79.4951 62.6665L79.724 64.351L80.7149 64.2163L80.486 62.5318Z"
          fill="black"
        />
        <path
          d="M79.5808 63.043L78.5899 63.1777L78.8189 64.8623L79.8098 64.7276L79.5808 63.043Z"
          fill="black"
        />
        <path
          d="M78.8803 63.1378L77.8894 63.2725L78.1184 64.957L79.1093 64.8223L78.8803 63.1378Z"
          fill="black"
        />
        <path
          d="M80.3691 62.3685L78.2882 62.6514L78.5441 64.5341L80.625 64.2512L80.3691 62.3685Z"
          fill="black"
        />
        <path
          d="M78.388 62.8321L77.3971 62.9668L77.6261 64.6513L78.617 64.5166L78.388 62.8321Z"
          fill="black"
        />
        <path
          d="M78.3789 62.3345L77.388 62.4692L77.617 64.1538L78.6079 64.0191L78.3789 62.3345Z"
          fill="black"
        />
        <path
          d="M77.359 62.0386L76.3681 62.1733L76.6375 64.1551L77.6284 64.0204L77.359 62.0386Z"
          fill="black"
        />
        <path
          d="M77.4852 62.9327L76.4943 63.0674L76.7233 64.7519L77.7142 64.6172L77.4852 62.9327Z"
          fill="black"
        />
        <path
          d="M76.8635 62.1392L75.8726 62.2739L76.142 64.2557L77.1329 64.121L76.8635 62.1392Z"
          fill="black"
        />
        <path
          d="M76.1778 62.5055L74.6914 62.7075L74.9204 64.3921L76.4067 64.19L76.1778 62.5055Z"
          fill="black"
        />
        <path
          d="M76.1861 61.9317L75.1952 62.0664L75.4242 63.7509L76.4151 63.6162L76.1861 61.9317Z"
          fill="black"
        />
        <path
          d="M75.3837 61.9214L74.1946 62.083L74.4236 63.7675L75.6127 63.6059L75.3837 61.9214Z"
          fill="black"
        />
        <path
          d="M74.9369 62.0411L73.946 62.1758L74.2559 64.4549L75.2468 64.3202L74.9369 62.0411Z"
          fill="black"
        />
        <path
          d="M74.285 62.9361L73.2941 63.0708L73.5231 64.7553L74.514 64.6206L74.285 62.9361Z"
          fill="black"
        />
        <path
          d="M73.6775 62.5318L72.6866 62.6665L72.9156 64.351L73.9065 64.2163L73.6775 62.5318Z"
          fill="black"
        />
        <path
          d="M74.0896 62.1343L73.0987 62.269L73.3277 63.9536L74.3186 63.8189L74.0896 62.1343Z"
          fill="black"
        />
        <path
          d="M73.139 62.3148L71.7518 62.5034L72.0616 64.7825L73.4488 64.5939L73.139 62.3148Z"
          fill="black"
        />
        <path
          d="M71.2849 63.2175L69.9967 63.3926L70.2257 65.0771L71.5139 64.902L71.2849 63.2175Z"
          fill="black"
        />
        <path
          d="M71.9846 63.2423L70.9937 63.377L71.2227 65.0615L72.2136 64.9268L71.9846 63.2423Z"
          fill="black"
        />
        <path
          d="M72.1857 62.2315L71.1948 62.3662L71.4238 64.0507L72.4147 63.916L72.1857 62.2315Z"
          fill="black"
        />
        <path
          d="M71.2845 62.0416L70.2936 62.1763L70.5226 63.8608L71.5135 63.7261L71.2845 62.0416Z"
          fill="black"
        />
        <path
          d="M71.4772 62.0213L68.7026 62.3984L68.9316 64.083L71.7061 63.7058L71.4772 62.0213Z"
          fill="black"
        />
        <path
          d="M70.8739 62.6199L68.0994 62.9971L68.3284 64.6816L71.1029 64.3044L70.8739 62.6199Z"
          fill="black"
        />
        <path d="M40.3 61.5H38.9V63.7H40.3V61.5Z" fill="black" />
        <path d="M39.3 62.5H37.9V64.7H39.3V62.5Z" fill="black" />
        <path d="M41.6 63.6001H37.2V66.0001H41.6V63.6001Z" fill="black" />
        <path d="M38.6 65.5H37.2V67.7H38.6V65.5Z" fill="black" />
        <path d="M41.6 66.1001H37.2V69.1001H41.6V66.1001Z" fill="black" />
        <path d="M39.3 67.5H37.9V69.7H39.3V67.5Z" fill="black" />
        <path d="M40 68.3999H38.6V70.5999H40V68.3999Z" fill="black" />
        <path d="M40.7 68.7998H39.3V70.9998H40.7V68.7998Z" fill="black" />
        <path d="M41.1 68.5H39.7V70.7H41.1V68.5Z" fill="black" />
        <path d="M41.8 68.2002H40.4V70.4002H41.8V68.2002Z" fill="black" />
        <path d="M42.5 67.1001H41.1V69.3001H42.5V67.1001Z" fill="black" />
        <path d="M42.7 66.1001H41.3V68.3001H42.7V66.1001Z" fill="black" />
        <path d="M42.7 64.3999H41.3V66.5999H42.7V64.3999Z" fill="black" />
        <path d="M42.4 63.6001H41V65.8001H42.4V63.6001Z" fill="black" />
        <path d="M42 62.8999H40.6V65.0999H42V62.8999Z" fill="black" />
        <path d="M41.9 62H39.8V64H41.9V62Z" fill="black" />
        <path
          d="M41.3188 68.6291L42.4088 68.481L42.1798 66.7964L41.0898 66.9446L41.3188 68.6291Z"
          fill="black"
        />
        <path
          d="M41.5938 67.114L42.6838 66.9658L42.4548 65.2813L41.3648 65.4295L41.5938 67.114Z"
          fill="black"
        />
        <path
          d="M41.1109 67.4148L42.2009 67.2666L41.9719 65.5821L40.8819 65.7302L41.1109 67.4148Z"
          fill="black"
        />
        <path
          d="M40.4388 66.6672L41.5287 66.519L41.2998 64.8345L40.2098 64.9827L40.4388 66.6672Z"
          fill="black"
        />
        <path
          d="M40.9786 66.2434L42.0686 66.0952L41.8396 64.4107L40.7496 64.5589L40.9786 66.2434Z"
          fill="black"
        />
        <path
          d="M40.9307 65.3327L42.0207 65.1846L41.7917 63.5L40.7017 63.6482L40.9307 65.3327Z"
          fill="black"
        />
        <path
          d="M40.3 65.4021L41.39 65.2539L41.161 63.5694L40.071 63.7175L40.3 65.4021Z"
          fill="black"
        />
        <path
          d="M39.5459 65.8835L40.6359 65.7354L40.4069 64.0508L39.3169 64.199L39.5459 65.8835Z"
          fill="black"
        />
        <path
          d="M39.5566 64.9118L40.6466 64.7637L40.4176 63.0791L39.3276 63.2273L39.5566 64.9118Z"
          fill="black"
        />
        <path
          d="M38.5889 63.2693L39.6789 63.1211L39.4499 61.4366L38.3599 61.5847L38.5889 63.2693Z"
          fill="black"
        />
        <path
          d="M39.1839 63.7414L40.2739 63.5933L40.0449 61.9087L38.9549 62.0569L39.1839 63.7414Z"
          fill="black"
        />
        <path
          d="M37.9444 64.734L40.0253 64.4512L39.5673 61.0821L37.4864 61.365L37.9444 64.734Z"
          fill="black"
        />
        <path
          d="M37.725 63.9411L38.815 63.793L38.586 62.1084L37.496 62.2566L37.725 63.9411Z"
          fill="black"
        />
        <path
          d="M38.0822 60.8345L37.0913 60.9692L37.3203 62.6538L38.3112 62.5191L38.0822 60.8345Z"
          fill="black"
        />
        <path
          d="M37.8875 61.3321L36.8966 61.4668L37.1256 63.1513L38.1165 63.0166L37.8875 61.3321Z"
          fill="black"
        />
        <path
          d="M36.9824 61.8433L35.9915 61.978L36.2204 63.6626L37.2113 63.5279L36.9824 61.8433Z"
          fill="black"
        />
        <path
          d="M36.2819 61.9381L35.291 62.0728L35.5199 63.7573L36.5108 63.6226L36.2819 61.9381Z"
          fill="black"
        />
        <path
          d="M37.7707 61.1683L35.6898 61.4512L35.9457 63.3339L38.0266 63.051L37.7707 61.1683Z"
          fill="black"
        />
        <path
          d="M35.7761 61.5328L34.7852 61.6675L35.0141 63.352L36.005 63.2173L35.7761 61.5328Z"
          fill="black"
        />
        <path
          d="M35.7805 61.1343L34.7896 61.269L35.0185 62.9536L36.0094 62.8189L35.7805 61.1343Z"
          fill="black"
        />
        <path
          d="M34.7606 60.8389L33.7697 60.9736L34.0391 62.9554L35.03 62.8207L34.7606 60.8389Z"
          fill="black"
        />
        <path
          d="M34.8867 61.733L33.8958 61.8677L34.1247 63.5522L35.1156 63.4175L34.8867 61.733Z"
          fill="black"
        />
        <path
          d="M34.265 60.939L33.2741 61.0737L33.5435 63.0555L34.5344 62.9208L34.265 60.939Z"
          fill="black"
        />
        <path
          d="M33.5793 61.3058L32.093 61.5078L32.3219 63.1923L33.8083 62.9903L33.5793 61.3058Z"
          fill="black"
        />
        <path
          d="M33.5876 60.7315L32.5967 60.8662L32.8257 62.5507L33.8166 62.416L33.5876 60.7315Z"
          fill="black"
        />
        <path
          d="M32.6862 60.7348L31.4971 60.8965L31.7261 62.581L32.9152 62.4194L32.6862 60.7348Z"
          fill="black"
        />
        <path
          d="M32.3385 60.8409L31.3476 60.9756L31.6574 63.2547L32.6483 63.12L32.3385 60.8409Z"
          fill="black"
        />
        <path
          d="M31.6866 61.7364L30.6957 61.8711L30.9247 63.5556L31.9156 63.4209L31.6866 61.7364Z"
          fill="black"
        />
        <path
          d="M31.0791 61.3316L30.0882 61.4663L30.3172 63.1508L31.3081 63.0161L31.0791 61.3316Z"
          fill="black"
        />
        <path
          d="M31.4777 60.8355L30.4868 60.9702L30.7158 62.6547L31.7067 62.52L31.4777 60.8355Z"
          fill="black"
        />
        <path
          d="M30.5406 61.1146L29.1533 61.3032L29.4631 63.5823L30.8504 63.3937L30.5406 61.1146Z"
          fill="black"
        />
        <path
          d="M28.6864 62.0178L27.3983 62.1929L27.6272 63.8774L28.9154 63.7023L28.6864 62.0178Z"
          fill="black"
        />
        <path
          d="M29.3862 62.0421L28.3953 62.1768L28.6243 63.8613L29.6152 63.7266L29.3862 62.0421Z"
          fill="black"
        />
        <path
          d="M29.5872 61.0313L28.5963 61.166L28.8253 62.8505L29.8162 62.7158L29.5872 61.0313Z"
          fill="black"
        />
        <path
          d="M28.6861 60.8414L27.6952 60.9761L27.9242 62.6606L28.9151 62.5259L28.6861 60.8414Z"
          fill="black"
        />
        <path
          d="M28.8787 60.8211L26.1042 61.1982L26.3332 62.8828L29.1077 62.5056L28.8787 60.8211Z"
          fill="black"
        />
        <path
          d="M28.2755 61.4202L25.501 61.7974L25.73 63.4819L28.5045 63.1047L28.2755 61.4202Z"
          fill="black"
        />
        <path
          d="M48.7384 59.184L50.3312 60.0225L51.123 58.5181L49.5302 57.6797L48.7384 59.184Z"
          fill="black"
        />
        <path
          d="M48.718 60.749L50.3109 61.5874L51.1027 60.0831L49.5099 59.2446L48.718 60.749Z"
          fill="black"
        />
        <path
          d="M47.9926 60.0878L49.5854 60.9263L50.3773 59.4219L48.7845 58.5835L47.9926 60.0878Z"
          fill="black"
        />
        <path
          d="M46.8145 60.4868L48.4073 61.3252L49.1992 59.8209L47.6064 58.9824L46.8145 60.4868Z"
          fill="black"
        />
        <path
          d="M47.5478 61.2968L49.1406 62.1353L49.9325 60.6309L48.3397 59.7925L47.5478 61.2968Z"
          fill="black"
        />
        <path
          d="M47.1922 62.0668L48.785 62.9053L49.5769 61.4009L47.9841 60.5625L47.1922 62.0668Z"
          fill="black"
        />
        <path
          d="M46.2557 61.5947L47.8486 62.4331L48.6404 60.9288L47.0476 60.0903L46.2557 61.5947Z"
          fill="black"
        />
        <path
          d="M45.3195 60.6059L46.9124 61.4443L47.7042 59.94L46.1114 59.1016L45.3195 60.6059Z"
          fill="black"
        />
        <path
          d="M44.9513 61.5571L46.5441 62.3955L47.336 60.8912L45.7432 60.0527L44.9513 61.5571Z"
          fill="black"
        />
        <path
          d="M43.0881 62.6274L44.6809 63.4658L45.4728 61.9615L43.8799 61.1231L43.0881 62.6274Z"
          fill="black"
        />
        <path
          d="M44.1584 62.5693L45.7512 63.4077L46.5431 61.9034L44.9503 61.0649L44.1584 62.5693Z"
          fill="black"
        />
        <path
          d="M41.6242 62.2696L44.7214 63.8999L46.3051 60.8912L43.2079 59.2609L41.6242 62.2696Z"
          fill="black"
        />
        <path
          d="M41.9337 61.4438L43.5266 62.2822L44.3184 60.7779L42.7256 59.9395L41.9337 61.4438Z"
          fill="black"
        />
        <path
          d="M43.1188 61.548L41.703 60.8027L40.9111 62.3071L42.327 63.0523L43.1188 61.548Z"
          fill="black"
        />
        <path
          d="M42.9208 60.9543L41.505 60.209L40.7131 61.7133L42.129 62.4586L42.9208 60.9543Z"
          fill="black"
        />
        <path
          d="M41.7891 59.9489L40.3733 59.2036L39.5814 60.7079L40.9973 61.4532L41.7891 59.9489Z"
          fill="black"
        />
        <path
          d="M40.6981 59.3522L39.2823 58.6069L38.4904 60.1113L39.9063 60.8565L40.6981 59.3522Z"
          fill="black"
        />
        <path
          d="M42.9219 61.016L39.8248 59.3857L38.9397 61.0671L42.0369 62.6974L42.9219 61.016Z"
          fill="black"
        />
        <path
          d="M39.7964 59.361L38.3806 58.6157L37.5887 60.12L39.0045 60.8653L39.7964 59.361Z"
          fill="black"
        />
        <path
          d="M39.7126 59.7614L38.2968 59.0161L37.5049 60.5204L38.9207 61.2657L39.7126 59.7614Z"
          fill="black"
        />
        <path
          d="M38.2614 59.1886L36.8456 58.4434L35.914 60.2132L37.3298 60.9584L38.2614 59.1886Z"
          fill="black"
        />
        <path
          d="M38.492 58.6759L37.0762 57.9307L36.2843 59.435L37.7002 60.1803L38.492 58.6759Z"
          fill="black"
        />
        <path
          d="M37.4738 58.7609L36.058 58.0156L35.1264 59.7854L36.5422 60.5307L37.4738 58.7609Z"
          fill="black"
        />
        <path
          d="M36.4812 58.1667L34.3575 57.0488L33.5656 58.5532L35.6894 59.6711L36.4812 58.1667Z"
          fill="black"
        />
        <path
          d="M36.2136 58.7629L34.7978 58.0176L34.0059 59.5219L35.4218 60.2672L36.2136 58.7629Z"
          fill="black"
        />
        <path
          d="M35.0952 58.2736L33.2369 57.2954L32.4451 58.7997L34.3034 59.7779L35.0952 58.2736Z"
          fill="black"
        />
        <path
          d="M34.7445 57.3136L33.3287 56.5684L32.2573 58.6036L33.6732 59.3489L34.7445 57.3136Z"
          fill="black"
        />
        <path
          d="M33.6133 56.5534L32.1974 55.8081L31.4056 57.3124L32.8214 58.0577L33.6133 56.5534Z"
          fill="black"
        />
        <path
          d="M32.6184 56.485L31.2025 55.7397L30.4107 57.2441L31.8265 57.9894L32.6184 56.485Z"
          fill="black"
        />
        <path
          d="M33.1002 57.2702L31.6843 56.5249L30.8925 58.0292L32.3083 58.7745L33.1002 57.2702Z"
          fill="black"
        />
        <path
          d="M32.1186 55.8904L29.9949 54.7725L28.9235 56.8077L31.0473 57.9257L32.1186 55.8904Z"
          fill="black"
        />
        <path
          d="M29.1646 54.3942L27.3063 53.416L26.5145 54.9203L28.3728 55.8985L29.1646 54.3942Z"
          fill="black"
        />
        <path
          d="M30.3204 54.7858L28.9046 54.0405L28.1127 55.5449L29.5286 56.2901L30.3204 54.7858Z"
          fill="black"
        />
        <path
          d="M30.2101 55.8747L28.7943 55.1294L28.0024 56.6337L29.4182 57.379L30.2101 55.8747Z"
          fill="black"
        />
        <path
          d="M28.8845 55.571L27.4687 54.8257L26.6768 56.33L28.0927 57.0753L28.8845 55.571Z"
          fill="black"
        />
        <path
          d="M29.1463 55.6446L25.0757 53.502L24.2839 55.0063L28.3544 57.149L29.1463 55.6446Z"
          fill="black"
        />
        <path
          d="M28.4338 54.6759L24.3632 52.5332L23.5714 54.0375L27.6419 56.1802L28.4338 54.6759Z"
          fill="black"
        />
        <path
          d="M63.2044 58.3971L61.7001 59.189L62.4919 60.6933L63.9963 59.9014L63.2044 58.3971Z"
          fill="black"
        />
        <path
          d="M63.2188 60.0084L61.7145 60.8003L62.5063 62.3046L64.0107 61.5128L63.2188 60.0084Z"
          fill="black"
        />
        <path
          d="M63.9155 59.3854L62.4111 60.1772L63.203 61.6816L64.7073 60.8897L63.9155 59.3854Z"
          fill="black"
        />
        <path
          d="M64.9955 59.7184L63.4911 60.5103L64.283 62.0146L65.7873 61.2227L64.9955 59.7184Z"
          fill="black"
        />
        <path
          d="M64.4006 60.4943L62.8962 61.2861L63.6881 62.7905L65.1924 61.9986L64.4006 60.4943Z"
          fill="black"
        />
        <path
          d="M64.7086 61.3087L63.2042 62.1006L63.9961 63.6049L65.5004 62.8131L64.7086 61.3087Z"
          fill="black"
        />
        <path
          d="M65.5936 60.8082L64.0892 61.6001L64.8811 63.1044L66.3854 62.3126L65.5936 60.8082Z"
          fill="black"
        />
        <path
          d="M66.5167 59.9274L65.0123 60.7192L65.8042 62.2236L67.3085 61.4317L66.5167 59.9274Z"
          fill="black"
        />
        <path
          d="M66.8937 60.799L65.3893 61.5908L66.1812 63.0952L67.6855 62.3033L66.8937 60.799Z"
          fill="black"
        />
        <path
          d="M68.7032 61.9264L67.1989 62.7183L67.9908 64.2226L69.4951 63.4307L68.7032 61.9264Z"
          fill="black"
        />
        <path
          d="M67.6999 61.8165L66.1956 62.6084L66.9874 64.1127L68.4917 63.3209L67.6999 61.8165Z"
          fill="black"
        />
        <path
          d="M69.3177 60.0276L66.3091 61.6113L67.8928 64.62L70.9015 63.0363L69.3177 60.0276Z"
          fill="black"
        />
        <path
          d="M69.9084 60.6891L68.4041 61.481L69.1959 62.9853L70.7002 62.1934L69.9084 60.6891Z"
          fill="black"
        />
        <path
          d="M70.2372 63.8551L71.6531 63.1099L70.8612 61.6055L69.4454 62.3508L70.2372 63.8551Z"
          fill="black"
        />
        <path
          d="M70.4456 63.2775L71.8615 62.5322L71.0696 61.0279L69.6538 61.7732L70.4456 63.2775Z"
          fill="black"
        />
        <path
          d="M71.5179 62.2858L72.9338 61.5405L72.1419 60.0362L70.7261 60.7815L71.5179 62.2858Z"
          fill="black"
        />
        <path
          d="M72.6279 61.6271L74.0438 60.8818L73.2519 59.3775L71.8361 60.1228L72.6279 61.6271Z"
          fill="black"
        />
        <path
          d="M70.6331 63.4353L73.6418 61.8516L72.7568 60.1703L69.7481 61.754L70.6331 63.4353Z"
          fill="black"
        />
        <path
          d="M73.5349 61.6462L74.9507 60.9009L74.1589 59.3965L72.743 60.1418L73.5349 61.6462Z"
          fill="black"
        />
        <path
          d="M73.6403 62.1076L75.0562 61.3623L74.2643 59.858L72.8485 60.6033L73.6403 62.1076Z"
          fill="black"
        />
        <path
          d="M75.1924 61.756L76.6083 61.0107L75.6767 59.2409L74.2608 59.9862L75.1924 61.756Z"
          fill="black"
        />
        <path
          d="M74.841 60.9767L76.2568 60.2314L75.465 58.7271L74.0491 59.4724L74.841 60.9767Z"
          fill="black"
        />
        <path
          d="M75.9395 61.3864L77.3553 60.6411L76.4237 58.8713L75.0079 59.6166L75.9395 61.3864Z"
          fill="black"
        />
        <path
          d="M76.7708 60.5945L78.8945 59.4766L78.1027 57.9722L75.9789 59.0902L76.7708 60.5945Z"
          fill="black"
        />
        <path
          d="M76.9715 61.1379L78.3873 60.3926L77.5955 58.8882L76.1796 59.6335L76.9715 61.1379Z"
          fill="black"
        />
        <path
          d="M78.2009 60.6499L79.9707 59.7183L79.1788 58.2139L77.409 59.1455L78.2009 60.6499Z"
          fill="black"
        />
        <path
          d="M78.7925 60.1852L80.2084 59.4399L79.137 57.4047L77.7212 58.15L78.7925 60.1852Z"
          fill="black"
        />
        <path
          d="M79.5019 58.9963L80.9177 58.251L80.1259 56.7466L78.71 57.4919L79.5019 58.9963Z"
          fill="black"
        />
        <path
          d="M80.5947 58.9479L82.0105 58.2026L81.2186 56.6983L79.8028 57.4436L80.5947 58.9479Z"
          fill="black"
        />
        <path
          d="M80.0643 59.6481L81.4801 58.9028L80.6882 57.3985L79.2724 58.1438L80.0643 59.6481Z"
          fill="black"
        />
        <path
          d="M81.3673 58.9146L83.4026 57.8433L82.3312 55.808L80.296 56.8793L81.3673 58.9146Z"
          fill="black"
        />
        <path
          d="M83.9272 56.8546L85.7855 55.8765L84.9936 54.3721L83.1353 55.3503L83.9272 56.8546Z"
          fill="black"
        />
        <path
          d="M82.8368 57.2121L84.2526 56.4668L83.4608 54.9625L82.0449 55.7077L82.8368 57.2121Z"
          fill="black"
        />
        <path
          d="M82.9534 58.3454L84.3692 57.6001L83.5773 56.0958L82.1615 56.841L82.9534 58.3454Z"
          fill="black"
        />
        <path
          d="M84.1924 57.9841L85.6083 57.2388L84.8164 55.7344L83.4006 56.4797L84.1924 57.9841Z"
          fill="black"
        />
        <path
          d="M83.9508 58.078L87.9329 55.9819L87.141 54.4776L83.159 56.5737L83.9508 58.078Z"
          fill="black"
        />
        <path
          d="M84.6478 57.1107L88.6299 55.0146L87.838 53.5103L83.856 55.6064L84.6478 57.1107Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="111.6" height="134.9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
